import ErrorHandler from '@mta/mta-js-framework/mta-error-handler/error-handler.js';
import MsgpackJsonAuthClient from '@mta/msgpack-js-lib/src/MsgpackJsonAuthClient.js';
import B2bPublicLogServiceClientProxy from '../gen/com/arabellesolutions/sdc/b2b/pub/log/B2bPublicLogServiceClientProxy.js';
import './b2b-public-app.js';

fetch('ui-conf')
    .then(data => {
      data.json().then(conf => {
        window.conf = conf;

        const errorHandler = new ErrorHandler((message, stackTrace, url, userAgent, launchDate) => {
          const logClient = MsgpackJsonAuthClient.build(conf.serverPublicAddress + '/public');
          const logService = new B2bPublicLogServiceClientProxy(logClient);

          document.querySelector('b2b-public-app').displayErrorMessage(message);

          logService.log(message, stackTrace, url, userAgent, 'b2b-public-ui', conf.applicationVersion, launchDate)
              .catch(e => {
                // Avoid infinit loop of loggin !
                // eslint-disable-next-line no-console
                console.error(e);
              });
        });
        errorHandler.register();

        document.body.append(document.createElement('b2b-public-app'));
      });
    });
